import { z } from 'zod';

/** Liste controllate del mondo Progetto: stato progetto, fase, scadenza. */

export const StatoProgetto = z.enum(['Attivo', 'Sospeso', 'Annullato', 'Chiuso']);
export type StatoProgetto = z.infer<typeof StatoProgetto>;

export const StatoFase = z.enum(['Aperta', 'Chiusa']);
export type StatoFase = z.infer<typeof StatoFase>;

export const StatoScadenza = z.enum(['Da fare', 'In corso', 'Completata', 'Scaduta']);
export type StatoScadenza = z.infer<typeof StatoScadenza>;
